import { render, staticRenderFns } from "./FormsHistoryTable.vue?vue&type=template&id=55f88dbe&scoped=true"
import script from "./FormsHistoryTable.vue?vue&type=script&lang=js"
export * from "./FormsHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./FormsHistoryTable.vue?vue&type=style&index=0&id=55f88dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f88dbe",
  null
  
)

export default component.exports